import { ReactNode } from "react";
import { FormSpy, FormSpyRenderProps } from "react-final-form";
import { FormSubscription } from "final-form";

interface ConditionalSubformProps {
  condition: (spyProps: FormSpyRenderProps) => boolean;
  renderOnSatisfy: (spyProps: FormSpyRenderProps) => ReactNode;
  renderOnFail?: (spyProps: FormSpyRenderProps) => ReactNode;
  subscription?: FormSubscription;
}

const ConditionalSubform = ({
  condition,
  renderOnSatisfy = () => null,
  renderOnFail = () => null,
  subscription
}: ConditionalSubformProps) => (
  <FormSpy
    subscription={subscription}
    render={(state: FormSpyRenderProps) =>
      (condition(state) ? renderOnSatisfy : renderOnFail)(state)
    }
  />
);

export default ConditionalSubform;
